module.exports = __webpack_public_path__ + "img/VERTIV.c3251de9.png";